import { authClient } from '#features/auth/auth-service'

export function useImpersonation() {
  const session = authClient.useSession()

  const isImpersonating = !!session.data?.session?.impersonatedBy

  const stopImpersonating = async () => {
    await authClient.admin.stopImpersonating()
    window.location.href = '/admin'
  }

  return {
    isImpersonating,
    impersonatedUser: isImpersonating ? session.data?.user : null,
    stopImpersonating,
  }
}
